export default "__VITE_ASSET__p2iJQo1Z__"